var _path, _path2, _path3, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 3",
    viewBox: "0 0 64 64",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.591,23.193,54,16.893V10a1,1,0,0,0-1-1H43.237L32.591,1.193a1,1,0,0,0-1.182,0L20.763,9H11a1,1,0,0,0-1,1v6.893l-8.591,6.3A1,1,0,0,0,1,24V62a1,1,0,0,0,1,1H62a1,1,0,0,0,1-1V24A1,1,0,0,0,62.591,23.193ZM26.261,42.968,3,60.026V25.969ZM32,41.24,58.945,61H5.055Zm5.739,1.728L61,25.969V60.026ZM60.307,24,54,28.607V19.374ZM32,3.24,39.854,9H24.146ZM52,11V30.069L36.047,41.727l-3.456-2.534a1,1,0,0,0-1.182,0l-3.456,2.534L12,30.069V11ZM10,28.607,3.693,24,10,19.374Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32,31a9,9,0,1,0-9-9A9.01,9.01,0,0,0,32,31Zm0-16a7,7,0,1,1-7,7A7.008,7.008,0,0,1,32,15Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30,26a1,1,0,0,0,.707-.293l6-6-1.414-1.414L30,23.586l-1.293-1.293-1.414,1.414,2,2A1,1,0,0,0,30,26Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 33,
    width: 16,
    height: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 33,
    width: 4,
    height: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.03504e7bdd6c1a0cfa396cb5ce670476.svg";
export { ForwardRef as ReactComponent };